import styled from "styled-components"

export const Floor = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`

export const Span = styled.span`
  display: flex;
  align-items: center;
  font-size: 13px;
  svg {
    margin-left: 5px;
    height: 15px;
  }
`

export const StakeWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 10px 5px;
`
